import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { price } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Always-visible checkout shortcut on small screens: it appears once the
 * visitor scrolls past the hero and hides again over the offer section.
 *
 * Visibility is driven by an IntersectionObserver (no per-scroll layout reads),
 * so it never forces a synchronous reflow while scrolling.
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('offer');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-shell px-4 py-3 transition-[opacity,transform] duration-200 ease-out sm:hidden ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-200" data-mp="gwgxpkkbcu26">
      <a href="#offer" onClick={() => trackPixelEvent('ViewContent', {
      content_name: 'The Art Flow Archive offer',
      value: 27,
      currency: 'USD'
    })} className="flex w-full items-center justify-center gap-2.5 rounded-full bg-gold px-6 py-3.5 font-sans text-[13px] font-semibold uppercase tracking-[0.12em] text-ink transition-colors duration-150 ease-out hover:bg-gold-ink hover:text-ivory focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-ink" data-id="element-201" data-mp="lus7jvalz4ke">
        Get the system — {price}
        <ArrowRightIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-202" data-mp="10l003rgx7q6q" />
      </a>
    </div>;
}